import React, { Component, PropTypes } from 'react';
import { Form, Col, FormGroup, ControlLabel, FormControl, Button, Modal } from 'react-bootstrap';
import axios from 'axios';
import ProgressBar from '../components/progressBar/ProgressBar';
import config from '../../config/config';

const appUrlPath = `/${config.appUrlPath}`;

export class Login extends Component {
  static propTypes = {
    username: PropTypes.string,
    password: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      showModal: false,
      message: '',
      isLoading: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeUsername = this.handleChangeUsername.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.close = this.close.bind(this);

    axios.get(`${appUrlPath}/getCsrfToken`, {
      params: {}
    })
    .then((res) => {
      axios.defaults.headers.common = {
        'CSRF-TOKEN': res.data.csrfToken
      };
    })
    .catch(() => {
    });
  }

  handleChangeUsername(event) {
    this.setState({ username: event.target.value });
  }
  handleChangePassword(event) {
    this.setState({ password: event.target.value });
  }
  handleSubmit(event) {
    event.preventDefault();
    if (this.state.username && this.state.password) {
      this.setState({ isLoading: true })
      axios.post('/motorb2b/login', {
        username: this.state.username,
        password: this.state.password
      })
      .then((res) => {
        if (res.data.isAuth) {
          window.location = '/en/motorb2b/home';
        } else {
          this.setState({
            message: res.data.errorMessage,
            showModal: true
          });
        }
        this.setState({ isLoading: false })
      })
      .catch((err) => {
        if (!err.response.data.isAuth) {
          let ms;
          if (err.response.data.errorMessage) {
            ms = err.response.data.errorMessage[0];
          } else {
            ms = 'Invalid access. Please try again with correct credentials or contact Admin.';
          }
          this.setState({
            message: ms,
            showModal: true,
            isLoading: false
          });
        }
      });
    } else {
      this.setState({
        message: 'Username and password cannot be null.',
        showModal: true
      });
    }
  }

  close() {
    this.setState({ showModal: false });
  }

  handleChangeForgotPassword(e) {
    e.preventDefault()
    window.location = '/en/motorb2b/forgotPassword';
  }

  render() {    
    if (this.state.isLoading) {
      return (
        <ProgressBar />
      )
    }

    const downloadTnC = `${appUrlPath}/downloadTnC`;
    const downloadPersonalInformationCollection = `${appUrlPath}/downloadPersonalInformationCollection`;
    const downloadPrivacyPolicyStatement = `${appUrlPath}/downloadPrivacyPolicyStatement`;
    return (
      <div>
        {this.state.showModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.message}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>OK</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}
        <Form horizontal onSubmit={this.handleSubmit}>
          <div className="EBaoHome__Container">
            <div className="ebaoUtil__Form-50">
              <FormGroup controlId="formHorizontalEmail">
                <Col componentClass={ControlLabel} sm={3}>
                  Username
                </Col>
                <Col sm={9}>
                  <FormControl type="text"
                    placeholder="Username"
                    value={this.state.username}
                    autoComplete="off"
                    onChange={this.handleChangeUsername}
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={3}>
                  Password
                </Col>
                <Col sm={9}>
                  <FormControl type="password"
                    placeholder="Password"
                    autoComplete="off"
                    value={this.state.password}
                    onChange={this.handleChangePassword}
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col smOffset={3} sm={9}>
                  <button type="submit" className="btn btn-axa">Sign in</button>{' '}
                  <a href="/en/motorb2b/forgotPassword">Forgot Password</a>
                </Col>
              </FormGroup>
              <Col sm={12}>
                By logging in, you agree to accept the <a target="_blank" rel="noopener noreferrer" href={downloadTnC}>Terms and Conditions</a> for Access to and Use of the System. <a target="_blank" rel="noopener noreferrer" href={downloadPersonalInformationCollection} >Personal Information Collection Statement</a> and <a target="_blank" rel="noopener noreferrer" href={downloadPrivacyPolicyStatement}>Privacy Policy Statement</a> of this online application.
              </Col>
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/app/pages/Login.js